import React from "react";
import Select from "react-select";
import { useQualifiers } from "../contexts/ResultsContext";

export default function Qualifier({ value, onChange }) {
  const qualifiers = useQualifiers();
  const handleChange = (e) => onChange(parseInt(e.target.value));
  return (
    <select value={value} onChange={handleChange} class="q-sel">
      {qualifiers.map((q) => (
        <option key={q.id} value={q.id}>
          {q.text}
        </option>
      ))}
    </select>
  );
}
